<div class="a-title">REGISTRO DE ITINERARIOS</div>
<div class="p-2">
    <form [formGroup]="group" class="a-w1-column">
        <div class="a-w1-row a-center justify-content-center">
            <p-button label="Guardar" icon="pi pi-save" size="small" (onClick)="guardar()"></p-button>
            <p-button label="Salir" icon="pi pi-external-link" size="small" (onClick)="salir()"></p-button>
        </div>
        <div class="a-w1-row">
            <p-floatLabel class="a-w2" variant="on">
                <p-select formControlName="anio" [options]="ListaAnios" showClear="true" optionLabel="nombre"
                    filter="true" filterBy="nombre" size="small" styleClass="w-full">
                </p-select>
                <label for="on_label">Año</label>
            </p-floatLabel>
            <p-floatLabel class="a-w2" variant="on">
                <p-select formControlName="semana" [options]="ListaSemanas" showClear="true" optionLabel="codigo"
                    filter="true" filterBy="codigo" size="small" styleClass="w-full">
                </p-select>
                <label for="on_label">Semana</label>
            </p-floatLabel>
        </div>
        <div class="a-w1-row">
            <p-floatLabel class="a-w2" variant="on">
                <p-select formControlName="servicio" [options]="ListaServicios" showClear="true" optionLabel="nombre"
                    filter="true" filterBy="nombre" (onChange)="cargarServicio()" size="small" styleClass="w-full">
                </p-select>
                <label for="on_label">Servicios</label>
            </p-floatLabel>
            <p-floatLabel class="a-w2" variant="on">
                <p-select formControlName="nave" [options]="ListaNave" showClear="true" optionLabel="nombre"
                    filter="true" filterBy="nombre" size="small" styleClass="w-full" virtualScroll="true"
                    virtualScrollItemSize="36">
                </p-select>
                <label for="on_label">Nave</label>
            </p-floatLabel>
        </div>
        <div class="example-full-width-alterno-content table">
            <p-table [value]="NaveServicio" styleClass="border-1 border-200" size="small">
                <ng-template pTemplate="header">
                    <tr class="header-table text-sm">
                        <th>Navieras</th>
                        <th>POL</th>
                        <th>POD</th>
                        <th>Tiempo</th>
                        <th *ngIf="transaccion && transaccion === 'NUEVO'"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-i="rowIndex">
                    <tr class="body-table text-xs">
                        <td>{{ product.naviera }}</td>
                        <td>{{ product.origen }}</td>
                        <td>{{ product.destino }}</td>
                        <td>
                            <input class="p-inputtext-sm" type="text" pInputText placeholder="Tiempo de tránsito"
                                (input)="onTransitoChange($event, i)" [value]="product.transito" />
                        </td>
                        <td *ngIf="transaccion && transaccion === 'NUEVO'">
                            <p-checkbox [binary]="true" [inputId]="'checkbox-' + i"
                                (onChange)="onCheckboxChange($event, product)"></p-checkbox>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <div class="a-w1-row">
            <p-floatLabel class="a-w2" variant="on">
                <input type="text" formControlName="plazo" pInputText class="w-full" pSize="small" />
                <label for="on_label">Plazos</label>
            </p-floatLabel>
            <p-floatLabel class="a-w2" variant="on">
                <input type="text" formControlName="viaje" pInputText class="w-full" pSize="small" />
                <label for="on_label">Viaje</label>
            </p-floatLabel>
        </div>
        <div class="a-w1-row">
            <p-floatLabel class="a-w2" variant="on">
                <p-datePicker formControlName="etd" dateFormat="dd/mm/yy" class="w-full" styleClass="w-full"
                    appendTo="body" inputStyleClass="w-full text-xs" size="small" iconDisplay="input"></p-datePicker>
                <label for="on_label">ETD</label>
            </p-floatLabel>
        </div>
    </form>
</div>